export { LineDecorator } from "./LineDecorator";
export type { LineDecoratorProps } from "./LineDecorator";
